/**
 * What the plan shows: an eye beside the settings gear that opens a card of
 * per-machine view preferences. The walls always show; the built-ins and the
 * movable objects each turn on and off, in both views and in the exports. The
 * assembler adds each room's size under its name, and how rooms are named.
 * Both add the 3D quality. Its rows are core's `ROOM_EDITOR_VIEW_MENU` and
 * `FLOOR_PLAN_VIEW_MENU`.
 */

import { FLOOR_PLAN_VIEW_MENU, ROOM_EDITOR_VIEW_MENU } from '@kaiizen/kai-floor-plan-editor-core';
import { FloorPlanMenuCard } from './FloorPlanMenuCard';

export interface ViewMenuProps {
  /** The assembler's room labels: each room's size, and how rooms are named. */
  roomLabels?: boolean;
}

export const ViewMenu = ({ roomLabels = false }: ViewMenuProps): React.JSX.Element => (
  <FloorPlanMenuCard menu={roomLabels ? FLOOR_PLAN_VIEW_MENU : ROOM_EDITOR_VIEW_MENU} testId='view-menu-button' />
);
